<template>
  <div v-if="video" class="card tw-shadow-none">
    <div v-if="video.cover" class="card-image">
      <figure class="image is-16by9">
        <img v-lazy="video.cover.url" alt="Placeholder image" />
      </figure>
    </div>
    <div class="card-content tw-px-0">
      <p class="is-size-5 tw-text-black hover:tw-text-primary">
        <span class="tw-font-bold">{{ video.title }}</span>
      </p>

      <p class="tw-mt-2 tw-text-black-light">
        {{ video.description }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    video: {
      type: Object
    }
  }
}
</script>
